import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
  SimpleChanges,
} from '@angular/core';
import { Subject } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { AlertHelper } from '../../../../shared/components/helpers/alert.helpers';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HorasExtrasService } from 'src/app/pages/services/horasExtras/horasExtras.service';
import Swal from 'sweetalert2';
import { addMonths, getMonth, getYear, parseISO } from 'date-fns';
import { DiasLibresService } from 'src/app/pages/services/diasLibres/diasLibres.service';
import { DiasLibres } from 'src/app/shared/models/diasLibres.interface';

@Component({
  selector: 'app-lista-dias-libres',
  templateUrl: './lista-dias-libres.component.html',
  styleUrls: ['./lista-dias-libres.component.css'],
})
export class ListaDiasLibresComponent implements OnInit {
  @Output() horasExtrasValue: EventEmitter<number> = new EventEmitter();
  @Input() idColaborador!: any;
  @Input() contexto: 'liquidacion' | 'completo' = 'completo';

  debouncer: Subject<boolean> = new Subject();
  optionsDecimal = {
    digitGroupSeparator: '.',
    decimalCharacter: ',',
    decimalPlaces: 2,
    minimumValue: '0',
    negativePositiveSignBehavior: false,
    modifyValueOnUpDownArrow: false,
    upDownStep: 'progressive',
    emptyInputBehavior: 'null',
  };

  periodo: Date = new Date();
  textSearch: string = '';
  update_horasExtras: DiasLibres = {
    rut: 0,
    trabajador: '',
    fecha: '',
    horas: 0,
    descripcion: '',
  };

  listHorasFilter: any[] = []

  listaHoras: any;
  varibles: any;
  modalReference: any = null;

  displayedColumnsLiquidacion: string[] = ['fecha', 'horas', 'descripcion', 'actions'];
  displayedColumnsCompleto: string[] = ['rut', 'trabajador', 'fecha', 'horas', 'descripcion', 'actions'];
  displayedColumns: string[];

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  dataSource: any;
  horasExtras: any;
  trabajadores_aux: any;
  datePipe: any;
  totalvalorhoras: any;
  fecha: any;

  constructor(
    private alert: AlertHelper,
    private modalService: NgbModal,
    private horasExtrasService: HorasExtrasService,
    private diasLibresService: DiasLibresService
  ) {}

  async ngOnInit() {
    this.displayedColumns =
      this.contexto === 'liquidacion'
        ? this.displayedColumnsLiquidacion
        : this.displayedColumnsCompleto;
    if (!this.idColaborador) await this.TraerDatos(true);
  }

  async ngOnChanges(changes: SimpleChanges) {
    console.log("cambia algo");
    if (changes.rut || changes.periodo) {
      await this.TraerDatos(true);
    }
  }

  open(content: any, id: number) {
    this.diasLibresService.traerDiaLibreId(id).subscribe((res) => {
      if (res.success) {
        this.listaHoras = res.data;
      } else {
        console.error('No se pudieron obtener los datos para editar.');
      }
    });
    this.modalReference = this.modalService.open(content);
  }

  applyFilter() {
    const filterValue = this.textSearch;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  eliminar(content: any, id: any) {
    Swal.fire({
      title: 'Eliminar?',
      text: '¿Está seguro de eliminar este día libre?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: 'rgb(54 146 36)',
      cancelButtonColor: '#dc3545',
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Sí, eliminar',
    }).then((result) => {
      if (result.isConfirmed) {
        this.diasLibresService.eliminarDiasLibre(id).subscribe((res) => {
          if (res.success == true) {
            this.alert.success_small(res.msg!);
            this.debouncer.next(true);
            this.ngOnInit();
          } else {
            this.alert.error_small(res.msg!);
          }
        });
      }
    });
  }

  async TraerDatos(event: boolean) {
    const res = this.idColaborador
      ? await this.diasLibresService.traerTodasTrabajadorAsync(this.idColaborador)
      : await this.diasLibresService.traerTodosDiasLibresAsync();

    if (res.success) {

      this.listaHoras = res.data;
        this.listHorasFilter = this.listaHoras.filter(x => {
          const periodo = parseISO(x.fecha);
          const month = getMonth(this.periodo);
          const year = getYear(this.periodo);
          return getMonth(periodo) === month && getYear(periodo) === year;
        }).
        map((x) => ({
              rut: x['Trabajador.rut'] || 'No asignado',
              trabajador: `${x['Trabajador.nombres']?.toUpperCase() || 'No asignado'} ${x['Trabajador.apellidos']?.toUpperCase() || ''}`,
              fecha: x.fecha,
              horas: x.horas,
              descripcion: x.descripcion,
              id: x.id,
            }))
        .sort((a, b) => {
          const fechaA = new Date(a.fecha);
          const fechaB = new Date(b.fecha);
          return fechaB.getTime() - fechaA.getTime();
        });


      this.configurarTabla();
      this.debouncer.next(true);
    } else {
      this.alert.error_small(res.msg);
    }
  }

  configurarTabla() {
    this.dataSource = new MatTableDataSource(this.listHorasFilter);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    this.dataSource.filterPredicate = (data: any, filter: string) => {
      return this.configurarFilterPredicate(data, filter);
    };
  }

  configurarFilterPredicate(data: any, filter: string) {
    const texto = `${data.trabajador} ${data.descripcion} ${data.fecha}`.toLowerCase();
    const palabras = filter.toLowerCase().split(' ');
    return palabras.every(palabra => texto.includes(palabra));
  }


  actualizar_diaLibre() {
    this.diasLibresService.actualizarDiaLibre(this.listaHoras).subscribe((res) => {
      this.fecha = this.listaHoras.fecha;
      if (res.success == true) {
        this.alert.success_small(res.msg!);
        this.modalReference.close();
        this.TraerDatos(true);
        this.debouncer.next(true);
        this.ngOnInit();
      } else {
        this.alert.error_small(res.msg!);
      }
    });
  }

  quitarFiltro() {
    this.textSearch = '';
    this.dataSource.filter = this.textSearch;
  }

  normalizeText(texto: string): string {
    return texto
      .normalize('NFD')
      .replace(/([aeio])\u0301|(u)[\u0301\u0308]/gi, '$1$2')
      .normalize();
  }

  FiltrarDatos() {
    const month = getMonth(this.periodo);
    const year = getYear(this.periodo);
    this.listHorasFilter = this.listaHoras.filter((x: any) => {
      const periodo = parseISO(x.fecha);
      return getMonth(periodo) === month && getYear(periodo) === year;
    }).map((x) => ({
      rut: x['Trabajador.rut'] || 'No asignado',
      trabajador: `${x['Trabajador.nombres']?.toUpperCase() || 'No asignado'} ${x['Trabajador.apellidos']?.toUpperCase() || ''}`,
      fecha: x.fecha,
      horas: x.horas,
      descripcion: x.descripcion,
      id: x.id,
    }))
    this.configurarTabla();
    this.dataSource.filter = this.textSearch;
  }

  CambiarMes(direction: 'LEFT' | 'RIGHT') {
    const factor = direction === 'LEFT' ? -1 : 1;
    this.periodo = addMonths(this.periodo, factor);
    this.FiltrarDatos();
  }

}
